<template>
    <CInput
        :isValid="isValid"
        :value.sync="valueComponent"
        :placeholder="placeholder"
        :label="label"
        :type="type"
        :size="size"
        :autocomplete="autocomplete ? 'on': 'new-password'"
        :horizontal="horizontal"
        :invalidFeedback="invalidFeedback"
        :disabled="disabled"
    >
        <template #prepend-content>
            <span @click="toggleHiddenPassword()">
                <CIcon :name="icon" />
            </span>
        </template>
    </CInput>
</template>

<script>
import { eye } from "~/assets/icons/js/eye";
export default {
    name: "CCInputPassword",

    icons: {
        eye,
    },
    props: {
        isValid: {
            type: Boolean,
            default: null,
        },
        label: {
            type: String,
            default: null,
        },
        value: {
            default: null,
        },
        horizontal: {
            default: false,
        },
        placeholder: {
            default: null,
        },
        invalidFeedback: {
            default: undefined,
        },
        size: {
            default: undefined,
        },
        autocomplete:{
            type: Boolean,
            default: true,
        },
        disabled: {
            default: false,
        },
        under: {
            default: false,
        },
    },
    data() {
        return {
            hiddenPassword: true,
            valueComponent: null
        };
    },
    computed: {
        type() {
            return this.hiddenPassword ? "password" : "text";
        },
        icon(){
            return this.hiddenPassword ? "cil-lock-locked" : "cil-lock-unlocked";
        }
    },
    watch: {
        value() {
            this.valueComponent = this.value;
        },
        valueComponent() {
            this.$emit("update:value", this.valueComponent);
        },
    },
    methods: {
        toggleHiddenPassword() {
            this.hiddenPassword = !this.hiddenPassword;
        },
    },
    mounted(){
        this.valueComponent = this.value;
    }
};
</script>
<style lang="scss">
</style>